<template>
  <div v-loading="loading">
    <div class="breadcrumb">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ name: 'UserApps' }">应用列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{userApp ? userApp.app_name: ""}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="toolbar">
      <el-input class="search-input" placeholder="搜索姓名或证件号" clearable v-model.trim="searchKey"></el-input>
      <el-button size="small" @click="onSearchClicked"><i class="el-icon-search"></i></el-button>
      <el-button
        size="small"
        @click="onDeleteClicked"
        :disabled="id_no_selected.length === 0 || deleting"
        :loading="deleting"
      >删除</el-button>
    </div>

    <div class="id-table">
      <el-table
        :data="id_infos_calced"
        stripe
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          align="center"
          width="55">
        </el-table-column>
        <el-table-column
          label="头像"
          align="center"
          width="100">
          <template slot-scope="scope">
            <img :src="scope.row.photo" style="max-width: 6em">
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="姓名"
          align="center"
          min-width="150">
        </el-table-column>
        <el-table-column
          prop="gender"
          label="性别"
          align="center"
          width="60">
        </el-table-column>
        <el-table-column
          prop="age"
          label="年龄"
          align="center"
          width="60">
        </el-table-column>
        <el-table-column
          prop="national"
          label="民族"
          align="center"
          width="60">
        </el-table-column>
        <el-table-column
          prop="birthday"
          label="出生"
          align="center"
          width="125">
        </el-table-column>
        <el-table-column
          prop="id_no"
          label="身份证号"
          align="center"
          width="180">
        </el-table-column>
        <el-table-column
          prop="address"
          label="住址"
          align="center"
          min-width="250">
        </el-table-column>
        <el-table-column
          prop="period"
          label="有效期限"
          align="center"
          width="180">
        </el-table-column>
        <el-table-column
          prop="sign_organization"
          label="签发机关"
          align="center"
          min-width="180">
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination" v-if="total !== 0">
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="20"
        @current-change="onPageChange"
        :total="total">
      </el-pagination>
    </div>

  </div>
</template>

<script>
  import axios from "axios"

  export default {
    name: "IdInfos",
    data() {
      return {
        loading: true, // 页面加载指示
        deleting: false, // 删除中指示
        searchKey: "",
        userApp: null,
        id_infos: [],
        idInfoSelected: [],
        total: 0, // app中id总数
        page: 1, // 当前页
      }
    },
    created() {
      this.loadUserApp().then(userApp => {
        this.userApp = userApp;
        this.loadIdInfos();
      }).catch(err => this.$message.error("加载应用失败"))
    },
    computed: {
      id_infos_calced() {
        return this.id_infos.map(id => {
          id.age = this._calcAge(id.birthday);
          id.period = `${id.start_date}-${id.end_date}`;
          id.photo = !id.photo ? "" : `data:image/jpeg;base64, ${id.photo}`;
          return id
        })
      },
      id_no_selected() {
        return this.idInfoSelected.map(id => id.id_no)
      }
    },
    methods: {
      loadUserApp() {
        return new Promise((resolve, reject) => {
          if (this.$route.params.userApp) {
            resolve(this.$route.params.userApp);
          } else {
            axios.get(`/apps/${this.$route.params.app_key}/`)
              .then(resp => resolve(resp.data.app))
              .catch(err => reject(err))
          }
        })
      },
      loadIdInfos() {
        return new Promise((resolve, reject) => {
          axios.get(`/apps/${this.userApp.app_key}/id_infos/`, {
            params: {
              page: this.page,
              search_key: this.searchKey,
            }
          })
            .then(resp => {
              this.id_infos = resp.data.id_infos;
              this.total = resp.data.total;
              resolve();
            })
            .catch(err => reject(err))
            .finally(() => this.loading = false)
        })
      },
      onSearchClicked() {
        this.onPageChange(1);
      },
      onDeleteClicked() {
        this.deleting = true;
        axios.post(`/apps/${this.userApp.app_key}/id_infos/delete/`, {
          ids_no: this.id_no_selected,
        })
          .then()
          .catch(err => this.$message.error("删除数据失败"))
          .finally(() => {
            this.deleting = false;
            this.loadIdInfos();
          })
      },
      // 计算年龄
      _calcAge(birthday) {
        birthday = birthday.replace("年", "-");
        birthday = birthday.replace("月", "-");
        birthday = birthday.replace("日", "");
        let ageDifMs = Date.now() - new Date(birthday);
        let ageDate = new Date(ageDifMs); // miliseconds from epoch
        return Math.abs(ageDate.getUTCFullYear() - 1970);
      },
      handleSelectionChange(selected) {
        this.idInfoSelected = selected;
      },
      onPageChange(page) {
        this.loading = true;
        this.page = page;
        this.id_infos = [];
        this.idInfoSelected = [];
        this.loadIdInfos().then().catch(err => this.$message.error("加载数据失败"));
      },
    }
  }
</script>

<style lang="stylus" scoped>
  @import "../share/styles/bread_crumb.styl"

  .toolbar
    display flex
    justify-content flex-end
    height 40px
    margin-top 1em
    padding-right 1em
    & .search-input
      width 15em
    & .el-icon-search
      font-size 1.5em
    & .el-button + .el-button
      margin-left 0

  .id-table
    margin-top 1em

  .pagination
    display flex
    justify-content center
    margin-top 1em
    margin-bottom 1em
</style>



// WEBPACK FOOTER //
// src/components/IdInfos.vue